<template>
  <div class="blog-block blog-image">
    <div class="blog-image__picture">
      <img :src="data.image" :alt="data.caption" @load="emitLoad">
    </div>
    <div class="blog-image__caption">
      <span v-html="data.caption"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'blog-image',

  props: ['data'],

  methods: {
    emitLoad() {
      this.$parent.$emit('reload-boundries');
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-image {
  &__picture {
    img {
      max-width: 100%;
      min-width: 100%;
    }
  }

  &__caption {
    text-align: center;
    font-size: rem(18px);
    font-size: calc(18px * var(--rw));
    line-height: rem(30px);
    line-height: calc(30px * var(--rw));
    margin-top: 20px;

    font-family: 'IGT Frankling Gothic';
    font-weight: 500;
  }
}
</style>
